import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import type { Locale } from '@chess-uno/shared-protocol'
import type { StoredSession } from '../api/session.js'
import { SiteFooter, TopBar } from '../components/Chrome.js'
import { useI18n } from '../i18n/index.js'

/** Legal information of the site (non-professional individual publisher). */
export const LEGAL = {
  siteName: 'Chess-Uno',
  domain: 'chess-uno.com',
  updatedAt: { fr: '13 octobre 2026', en: 'October 13, 2026', es: '13 de octubre de 2026', de: '13. Oktober 2026', hi: '13 अक्टूबर 2026' } as Record<Locale, string>,
  contactEmail: 'contact@chess-uno.com',
  host: {
    name: 'Railway Corporation',
    address: {
      fr: '548 Market St PMB 68956, San Francisco, CA 94104, États-Unis',
      en: '548 Market St PMB 68956, San Francisco, CA 94104, United States',
      es: '548 Market St PMB 68956, San Francisco, CA 94104, Estados Unidos',
      de: '548 Market St PMB 68956, San Francisco, CA 94104, Vereinigte Staaten',
      hi: '548 Market St PMB 68956, San Francisco, CA 94104, संयुक्त राज्य अमेरिका',
    } as Record<Locale, string>,
    website: 'https://railway.com',
  },
}

export function Mail() {
  return <a href={`mailto:${LEGAL.contactEmail}`}>{LEGAL.contactEmail}</a>
}

export function LegalShell({ session, eyebrow, title, children }: { session: StoredSession | null; eyebrow: string; title: string; children: ReactNode }) {
  const { locale, t } = useI18n()
  return (
    <div className="app-shell">
      <TopBar session={session} />
      <main className="legal-page">
        <header className="page-head">
          <p className="eyebrow">{eyebrow}</p>
          <h1>{title}</h1>
          <p className="fine">{t.legal.updated(LEGAL.updatedAt[locale])}</p>
        </header>
        <article className="rules legal">{children}</article>
      </main>
      <SiteFooter />
    </div>
  )
}

/** Translation, for information: the French version prevails. `link` is the text of the link to it. */
export function TranslationNotice({ original, before, link, after }: { original: string; before: string; link: string; after: string }) {
  return (
    <p className="lead-p">
      {before}{' '}
      <Link to={original} hrefLang="fr" lang="fr">
        {link}
      </Link>{' '}
      {after}
    </p>
  )
}
